/** Wireframe “Efficiency” column — compact bar + label */
export function EfficiencyMiniBar({ pct, variant = 'good' }) {
  const barClass =
    variant === 'warn'
      ? 'bg-evault-gold'
      : variant === 'bad'
        ? 'bg-red-500'
        : 'bg-evault-teal-deep';
  const safe = Math.min(100, Math.max(0, pct));
  return (
    <div className="flex items-center gap-2">
      <div
        className="h-2 w-14 shrink-0 overflow-hidden rounded-full bg-evault-surface ring-1 ring-evault-border"
        title={`Efficiency ${safe}%`}
      >
        <div
          className={`h-full rounded-full ${barClass}`}
          style={{ width: `${safe}%` }}
        />
      </div>
      <span className="text-[10px] font-medium tabular-nums text-evault-muted">
        {safe}%
      </span>
    </div>
  );
}
